export const MaterialStatus = [
    { label: 'Never Married', value: 'never married' },
    { label: 'Married', value: 'married' },
    { label: 'Divorced', value: 'divorced' },
    { label: 'Widowed', value: 'widowed' },
    { label: 'Annulled', value: 'annulled' }
]